const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const isIpAddress = (hostname: string): boolean =>
  /^(?:\d{1,3}\.){3}\d{1,3}$/.test(hostname) || hostname.includes(':');

export const resolveRuntimeApiBaseUrl = (requestedBaseUrl?: string): string => {
  const requested = requestedBaseUrl?.trim();
  if (!requested || requested === 'same-origin') {
    return '';
  }

  let parsed: URL;
  try {
    parsed = new URL(requested);
  } catch {
    throw new Error('Runtime API must use an HTTPS domain origin or same-origin');
  }

  if (
    parsed.protocol !== 'https:' ||
    parsed.port ||
    parsed.username ||
    parsed.password ||
    parsed.hostname === 'localhost' ||
    isIpAddress(parsed.hostname) ||
    !parsed.hostname.includes('.')
  ) {
    throw new Error('Runtime API must use an HTTPS domain origin or same-origin');
  }

  return trimTrailingSlash(`${parsed.origin}${parsed.pathname === '/' ? '' : parsed.pathname}`);
};

export const resolveRuntimeApiUrl = (baseUrl: string, pathOrUrl: string): string => {
  let path = pathOrUrl.trim();
  if (/^https?:\/\//i.test(path)) {
    const parsed = new URL(path);
    path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${trimTrailingSlash(baseUrl)}${normalizedPath}`;
};
